export const formatUserNameForTelemetry = (user: {
  firstname: string;
  middlename?: null | string;
  lastname: string;
}) => {
  return [user.firstname, user.middlename, user.lastname]
    .filter(Boolean)
    .join(' ');
};

export const formatUserIdForTelemetry = (
  id: number,
  userType: 'practice' | 'global',
) => (userType === 'practice' ? `practiceuser.${id}` : `globaluser.${id}`);
